import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { CheckItem } from '../CheckItem';
import { solutionCycle, solutionItems } from '../../data/salesContent';
export function SolutionSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" style={{
    backgroundImage: 'radial-gradient(ellipse 60% 45% at 50% 0%, rgba(212,175,55,0.10), transparent 70%)'
  }} data-id="element-216" data-mp="1a22ao0qtms7u">
      <div className="mx-auto max-w-5xl" data-id="element-217" data-mp="ia364pzm6h3l">
        <SectionHeading title="Imaginá abrir un único sistema y encontrar todo organizado" data-id="element-218" data-mp="ib4ges8t2zk9" />
        <ul className="mx-auto mt-12 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-219" data-mp="mbepwevt483v">
          {solutionItems.map(item => <CheckItem key={item} className="rounded-xl border border-ink-line bg-ink-soft px-5 py-4 text-lg font-medium text-cream md:text-xl" data-id="element-220" data-mp="r47un2r9zgfy">
              {item}
            </CheckItem>)}
        </ul>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase text-cream md:text-4xl" data-id="element-221" data-mp="3upn8cu4m7iib">
          Eso es <span className="text-gold" data-id="element-222" data-mp="2xm3b2yuazx1n">Primeros Auxilios para Instructores™</span>
        </p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-223" data-mp="2sv4t7uto2qwa">
          {solutionCycle.map((step, i) => <li key={step} className="flex items-center gap-3 text-lg font-semibold text-neutral-200 md:text-xl" data-id="element-224" data-mp="2nv0ady5adk2w" data-mpi={i}>
              {step}
              {i < solutionCycle.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-225" data-mp="2evll320uvfjz" />}
            </li>)}
        </ol>
        <div className="mt-10" data-id="element-226" data-mp="29vh3t9s4igsp">
          <CtaButton data-id="element-227" data-mp="29wsfrwvq2uuw">Quiero dejar de empezar desde cero</CtaButton>
        </div>
      </div>
    </section>;
}